<script setup lang="ts">
// プロジェクトにフォントの原本を同梱したが、フォント自身が (OS/2 の fsType で) それを
// 許可していなかったときに出す。保存はすでに終わっている。止めるのではなく知らせるのが目的。
import { useModal } from '@/composables/useModalStack'
import { useI18n } from '@/i18n'
import { fontEmbedWarnings } from '@/text/fonts'

const emit = defineEmits<{ close: [] }>()
useModal('fontEmbed')
const { t } = useI18n()
const reason = (p: string) => (p === 'restricted' ? t('fontEmbed.restricted') : t('fontEmbed.previewPrint'))
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="emit('close')">
    <div class="modal" @keydown.esc="emit('close')">
      <h2>{{ t('fontEmbed.title') }}</h2>
      <p>{{ t('fontEmbed.body') }}</p>
      <ul class="fonts">
        <li v-for="f in fontEmbedWarnings" :key="f.family">
          <b>{{ f.family }}</b>
          <span class="muted">{{ reason(f.permission) }}</span>
        </li>
      </ul>
      <p class="muted small">{{ t('fontEmbed.note') }}</p>
      <div class="actions"><button class="primary" @click="emit('close')">{{ t('dialog.ok') }}</button></div>
    </div>
  </div>
</template>

<style scoped>
.fonts {
  margin: 10px 0;
  padding: 10px 12px;
  list-style: none;
  background: var(--bg-2);
  border-radius: 6px;
  max-height: 180px;
  overflow: auto;
}
.fonts li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;
}
.small {
  font-size: 12px;
  line-height: 1.6;
}
</style>
